import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface DeviceModel {
  id: number;
  name: string;
  canSendCommands: boolean;
  compatibleWialonNames: string[];
  params: string[];
  serverAddress: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeviceModelsService {
  private readonly httpClient = inject(HttpClient);

  list(): Observable<DeviceModel[]> {
    return this.httpClient.get<DeviceModel[]>('device_models/');
  }
}
